import { useRouter } from 'vue-router'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    faIcon: {
      type: [String,Array],
      default: null
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    badge: {
      type: [String, Number],
      default: null
    },
    badgeVariant: {
      type: String,
      default: 'gray'
    },
    target: {
      type: String,
      default: null
    }
  },
  computed: {
    toComputed() {
      if(this.target && this.target === '_blank') {
        return null
      }
      return this.to
    },
    hrefComputed() {
      if(this.to && useRouter()) {
        return useRouter().resolve(this.to).href
      }
      else if(this.href) {
        return this.href
      }
      return null
    },
    shouldBeComponent() {
      if(this.to && !this.target) {
        return 'router-link';
      }
      else if(this.to && this.target === '_blank') {
        return 'a';
      }
      else if(this.href) {
        return 'a'
      } else {
        return 'button';
      }
    },
    twClasses() {
      return [
        'btn',
        'btn-variant-' + this.variant,
        'btn-size-' + this.size,
        {'btn-pill': this.pill},
        {'btn-block': this.block}
      ];
    },
    loadingClasses() {
      return [
        'animate-spin',
        {'h-4 w-4' : this.size === 'default'},
        {'h-2 w-2' : this.size === 'xs'},
        {'h-3 w-3' : this.size === 'sm'},
        {'h-6 w-6' : this.size === 'lg'},
        {'h-7 w-7' : this.size === 'xl'},
        'transition-all',
        'ease-in-out',
        'duration-500',
        {'text-black': ['secondary'].indexOf(this.variant) > -1},
        {'text-blue': ['primary'].indexOf(this.variant) > -1},
        {'text-white': ['warning','danger','info'].indexOf(this.variant) > -1}
      ];
    },
    badgeClasses() {
      return [
        'badge',
        'badge-' + this.variant,
        'badge-pill'
      ];
    }
  },
  methods: {
    clickedMiddleButton() {
      if(this.to) {
        window.open(this.$router.resolve(this.to).href, '_blank')
      }
      return true
    }
  }
}
